const TABS = [
  { key: 'open',   label: 'Open' },
  { key: 'closed', label: 'Closed' },
];

export default function InvoiceTabs({ active, counts, onChange }) {
  return (
    <div className="tab-row">
      {TABS.map(t => (
        <button
          key={t.key}
          type="button"
          className={`tab ${active === t.key ? 'active' : ''}`}
          onClick={() => onChange(t.key)}
          aria-pressed={active === t.key}
        >
          {t.label}
          {counts[t.key] != null && <span className="tab-count">{counts[t.key]}</span>}
        </button>
      ))}
    </div>
  );
}
